import React                   from 'react';
import button                  from '../../images/button.png';
import { handleDefaultSignin } from '../../utils';
import { words }               from '../../utils/dictionary';
import { makeStyles }          from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
      buttonLink: {
        color:          '#FFF',
        textDecoration: 'none',
        zIndex:         999,
        width:          300,
        height:         50,
        position:      'fixed',
      },
      button: {
        backgroundImage:    `url(${ button })`,
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        backgroundColor:    'transparent',
        display:            'flex',
        alignItems:         'center',
        justifyContent:     'center',
        textAlign:          'center',
        width:              '100%',
        height:             '100%',
        color:              '#FFF',
        border:             'none',
        cursor:             'pointer',
        fontSize:           20,
      }
      
}))

type SignInButtonProps = {
    wideScreen: boolean;
    lang:       string;
}

const SignInButton: React.FC<SignInButtonProps> = ({ lang, wideScreen }) => {

  const classes = useStyles();

  const [rootStyle, rootStyle2] = React.useMemo(() => {
    return [{
       top:       wideScreen ? '45vh' : '50vh',
       left:      wideScreen ? '50vw' : '50%',
       transform: `translate(${ !wideScreen ? -50 : 0 }%, -25px)`
     },
     {
      top:       wideScreen ? '45vh' : '50vh',
      left:      wideScreen ? '50vw' : '50%',
      transform: `translate(${ !wideScreen ? -50 : 0 }%, 35px)`
    }
    ]
  },[wideScreen])

  return (
    <>
      <div
        className = { classes.buttonLink }
        style     = { rootStyle }
        onClick   = { () => { handleDefaultSignin(lang) }}
      >
          <button className = { classes.button }>
            { words[`defaultSignin`][lang] }
          </button>
      </div>
      <div
        className = { classes.buttonLink }
        style     = { rootStyle2 }
        onClick   = { () => { window.location.assign(`https://www.yisumatica.org.il/flash-upload/pisa-math/`); }}
      >
          <button className = { classes.button }>
             כניסה ללא הרשמה
          </button>
      </div>
    </>
  )
}



export default SignInButton;



